import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("backup.storagePlan.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, id, request) {
  return axios.put(
    api.path("backup.storagePlan.update", {
      contractId: contractId,
      id: id
    }),
    request
  );
}

export function list(contractId) {
  return axios.get(
    api.path("backup.storagePlan.index", { contractId: contractId })
  );
}

export function show(contractId, id) {
  return axios.get(
    api.path("backup.storagePlan.show", {
      contractId: contractId,
      id: id
    })
  );
}

export function remove(contractId, id, withBackups) {
  return axios.delete(
    api.path("backup.storagePlan.remove", {
      contractId: contractId,
      id: id
    }),{
      params: {
        withBackups: withBackups
      }
    }
  );
}

export function turnOn(contractId, id) {
  return axios.put(
    api.path("backup.storagePlan.turnOn", {
      contractId: contractId,
      id: id
    })
  );
}

export function turnOff(contractId, id) {
  return axios.put(
    api.path("backup.storagePlan.turnOff", {
      contractId: contractId,
      id: id
    })
  );
}
